export default class MediaFileInfo {
    id: number|undefined;
    contentType: string|undefined;
    ext: string|undefined;
    name: string|undefined;
    size: number|undefined;

    isImage() {
        if (!this.ext) {
            return false;
        }
        return ['png', 'jpg', 'jpeg', 'gif'].indexOf(this.ext) > -1
    }
}